import { auth } from '../constants/firebaseModular';
import { FileTypes } from '../types/Files/FileTypes';
export const getFileUploadPath = (type: FileTypes) => {
  const patientId = auth?.currentUser?.uid;
  switch (type) {
    case FileTypes.idFront: {
      return `user/${patientId}/images/photoIdentificationFront`;
    }
    case FileTypes.readerIdFront: {
      return `user/${patientId}/images/readerIdentificationFront`;
    }
    case FileTypes.idBack: {
      return `user/${patientId}/images/photoIdentificationBack`;
    }
    case FileTypes.livingWill: {
      return `user/${patientId}/files/livingWill.pdf`;
    }
    case FileTypes.POLST: {
      return `user/${patientId}/files/POLST.pdf`;
    }
    case FileTypes.powerOfAttorney: {
      return `user/${patientId}/files/powerOfAttorney.pdf`;
    }
    // TODO: RESTORE PATHS IF PORTAL HAS UPLOAD ERRORS (CHANGED 6/4/25)
    // case FileTypes.livingWill: {
    //   return `/${patientId}/files/livingWill`;
    // }
    // case FileTypes.POLST: {
    //   return `/${patientId}/files/POLST`;
    // }
    // case FileTypes.powerOfAttorney: {
    //   return `/${patientId}/files/powerOfAttorney`;
    // }
    case FileTypes.medicareFront: {
      return `user/${patientId}/images/medicareFront`;
    }
    case FileTypes.medicareBack: {
      return `user/${patientId}/images/medicareBack`;
    }
    case FileTypes.medicareFront2: {
      return `user/${patientId}/images/medicareFront2`;
    }
    case FileTypes.medicareBack2: {
      return `user/${patientId}/images/medicareBack2`;
    }
    case FileTypes.healthInsuranceFront: {
      return `user/${patientId}/images/healthInsuranceCardFront`;
    }
    case FileTypes.healthInsuranceBack: {
      return `user/${patientId}/images/healthInsuranceCardBack`;
    }
    case FileTypes.portrait: {
      return `user/${patientId}/images/portrait`;
    }
    default: {
      return `unknownFiles/${patientId}/`;
    }
  }
};
